/**
 * 运营管理
 */

import Layout from "../../pages/layout/Frame";

const operationRouter = {
  path: "/operation",
  component: Layout,
  meta: { title: "运营管理" },
  name: "operation",
  children: [
    {
      path: "/operation/index",
      component: () => import("../../pages/operation/index.vue"),
      meta: { title: "运营管理" },
      name: "operation_index"
    }
  ]
};

export default operationRouter;
